"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _querystring = _interopRequireDefault(require("querystring"));
var _downshift = _interopRequireDefault(require("downshift"));
var _uiTheme = require("@kyruus/ui-theme");
var _utils = require("./utils");
var _OptionList = _interopRequireDefault(require("./OptionList"));
var _styles = require("./styles");
/*eslint-disable no-prototype-builtins*/

const DEBOUNCE_MS = 300;

// Capitalize the first character of a string
const capitalizeFirst = str => {
  return str.charAt(0).toUpperCase() + (0, _slice.default)(str).call(str, 1);
};
class Typeahead extends _react.default.Component {
  constructor(props) {
    var _context, _context2, _context3, _context4;
    super(props);
    this.themed = key => (0, _uiTheme.fromTheme)(key)(props);
    this.fetchResponse = (0, _debounce.default)((0, _bind.default)(_context = this.fetchResponse).call(_context, this), DEBOUNCE_MS);
    this.onStateChange = (0, _bind.default)(_context2 = this.onStateChange).call(_context2, this);
    this.dsOnKeyHandler = (0, _bind.default)(_context3 = this.dsOnKeyHandler).call(_context3, this);
    this.clearSelectAndUpdateInput = (0, _bind.default)(_context4 = this.clearSelectAndUpdateInput).call(_context4, this);
    const inputValue = this.props.value || '';
    this.state = {
      items: [],
      selectedItem: inputValue ? {
        value: inputValue,
        label: this.convertValueToLabel(inputValue)
      } : null,
      inputValue
    };
  }
  componentWillUnmount() {
    this.unmounted = true;
  }

  // We use downshift as a controlled component, by managing the internal state of inputValue
  onStateChange(changes) {
    if (this.unmounted) return;
    if (changes.hasOwnProperty('selectedItem')) {
      this.setState({
        selectedItem: changes.selectedItem,
        inputValue: changes.selectedItem.value
      });
    } else if (changes.hasOwnProperty('inputValue')) {
      if (this.props.useTypeAhead) {
        this.setState({
          inputValue: changes.inputValue
        }, this.fetchResponse);
      } else {
        // Clears item selection while setting the internal input value state
        // Setting the input value inner state is necessary for tracking the value of the search bar.
        // This clears any selection but also keeps the internal value in sync so when enter is hit, the right
        // value is submitted.
        this.clearSelectAndUpdateInput(changes.inputValue);
      }
    }
  }
  getCurrentUrlParams() {
    const {
      inputValue
    } = this.state;
    const {
      categories,
      size,
      queryString: qsAdditions,
      version
    } = this.props;
    if (version === 'v8') {
      const typeaheadCategories = (0, _utils.formatSearchCategories)(categories);
      return _querystring.default.stringify({
        terms: inputValue,
        typeahead_categories: typeaheadCategories,
        size: size,
        ...qsAdditions
      });
    }
    if (version === 'v9') {
      let params = {
        terms: inputValue,
        categories: !categories ? '' : (0, _map.default)(categories).call(categories, cat => typeof cat === 'string' ? cat : cat.category).join(','),
        size: size,
        ...qsAdditions
      };
      const {
        transformQueryStringParams
      } = this.props;
      if (transformQueryStringParams) {
        params = transformQueryStringParams(params);
      }
      return _querystring.default.stringify(params);
    }
    throw new Error(`Unsupported version: ${version}. Version must be one of the following: 'v8', 'v9'.`);
  }
  dsOnKeyHandler(event, closeMenu, highlightedIndex, inputValue) {
    if (event.key == 'Enter') {
      // submit on enter or submit on enter always with no selected dropdown item
      if ((!this.props.useTypeAhead || !this.state.items.length) && this.props.submitOnEnter || this.props.submitOnEnterAlways && highlightedIndex === null) {
        event.preventDownshiftDefault = true;
        closeMenu();
        this.props.onSubmit(this.state.inputValue);
        this.setState({
          selectedItem: this.state.inputValue
        });
      }
      // close menu if this is a typeahead, input is empty, and no item selected
      else if (this.props.useTypeAhead && highlightedIndex === null && (0, _isEmpty2.default)(inputValue)) {
        event.preventDownshiftDefault = true;
        closeMenu();
      }
    } else if (event.key == 'Escape') {
      event.preventDownshiftDefault = true;
      closeMenu();
    } else {
      event.preventDownshiftDefault = false;
    }
  }
  clearSelectAndUpdateInput() {
    let inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.inputValue;
    // Default when updating input is no change
    this.setState({
      inputValue: inputValue,
      items: [],
      selectedItem: null
    });
  }
  convertValueToLabel(value) {
    return capitalizeFirst(value);
  }

  /**
   * Fetch the typeahead response from the Search Service proxy
   */
  async fetchResponse() {
    const {
      inputValue
    } = this.state;
    const {
      url,
      version,
      headers
    } = this.props;
    if (!inputValue) {
      return this.setState({
        items: []
      });
    }
    let response = {};
    try {
      const fetchOptions = {};
      if (headers) {
        fetchOptions.headers = headers;
      }
      response = await fetch(`${url}?${this.getCurrentUrlParams()}`, fetchOptions);
      if (!response.ok) {
        throw new Error(response.message);
      }
      response = await response.json();
    } catch (error) {
      // Return empty object if the endpoint is unavailable/returns a bad response
      response = {};
      this.props.onFetchError(error);
    }
    if (version === 'v8') {
      var _context5;
      const items = (0, _map.default)(_context5 = (0, _get2.default)(response, 'exact.docs', [])).call(_context5, item => ({
        ...item,
        value: item.value,
        label: this.convertValueToLabel(item.value)
      }));
      this.setState({
        items: items
      });
    } else if (version === 'v9') {
      var _context6;
      const items = [];
      (0, _forEach.default)(_context6 = (0, _keys.default)(response)).call(_context6, key => {
        var _context7;
        const values = (0, _map.default)(_context7 = response[key]).call(_context7, result => {
          return {
            ...result,
            content_type: key,
            value: result.name,
            label: result.name
          };
        });
        items.push(...values);
      });
      this.setState({
        items: items
      });
    }
  }
  render() {
    const {
      placement,
      ...props
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_downshift.default, (0, _extends2.default)({}, props, {
      onStateChange: this.onStateChange
      // This call prevents an event object being passed in as a parameter and set to the input's value
      ,
      onOuterClick: () => this.clearSelectAndUpdateInput(),
      itemToString: item => item ? item.value : '',
      selectedItem: this.state.selectedItem
    }), _ref => {
      let {
        getInputProps,
        getItemProps,
        isOpen,
        inputValue,
        highlightedIndex,
        closeMenu
      } = _ref;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "typeahead-widget"
      }, /*#__PURE__*/_react.default.createElement(_styles.StyledTypeaheadContainer, null, /*#__PURE__*/_react.default.createElement(_styles.StyledInput, getInputProps({
        'aria-describedby': this.props['aria-describedby'],
        placeholder: this.props.placeholder,
        onKeyDown: event => this.dsOnKeyHandler(event, closeMenu, highlightedIndex, inputValue)
      })), /*#__PURE__*/_react.default.createElement(_styles.InputSearchIcon, null), isOpen && this.props.useTypeAhead && /*#__PURE__*/_react.default.createElement(_OptionList.default, {
        placement: placement,
        items: this.state.items,
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        getItemProps: getItemProps,
        themed: this.themed,
        categories: this.props.categories
      })));
    });
  }
}
Typeahead.propTypes = {
  ..._downshift.default.propTypes,
  /**
   * Sets position of typeahead results list ("above" | "below")
   */
  placement: _propTypes.default.string,
  /**
   * Used to display placeholder text inside the input.
   */
  placeholder: _propTypes.default.string,
  /**
   * The value that the input will be initialized with.
   * The input does not become "controlled" - it is simply a starting value
   */
  value: _propTypes.default.string,
  /**
   * The typeahead categories to include:
   * for v8, see:
   *  https://support.kyruus.com/hc/en-us/articles/360000680183-Integrating-Typeahead-with-Search
   * for v9, see:
   *  https://support.kyruus.com/hc/en-us/articles/360051068671-Integrating-Typeahead-with-Search
   */
  categories: function (props, propName, componentName) {
    if (props.version === 'v8') {
      _propTypes.default.checkPropTypes({
        [propName]: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape({
          category: _propTypes.default.string,
          display: _propTypes.default.string
        })), _propTypes.default.string])
      }, props, propName, componentName);
    }
    if (props.version === 'v9') {
      const catStrings = ['clinical_keywords', 'conditions_symptoms', 'location_name', 'network_affiliation', 'practice_group', 'primary_care', 'provider_name', 'specialties', 'treatments_procedures', 'marketable_location_type', 'marketable_locations', 'marketable_location_services'];
      _propTypes.default.checkPropTypes({
        [propName]: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(catStrings)), _propTypes.default.arrayOf(_propTypes.default.shape({
          display: _propTypes.default.string,
          category: _propTypes.default.oneOf(catStrings)
        }))])
      }, props, propName, componentName);
    }
  },
  /**
   * The url of the Search Service typeahead proxy (can be relative or absolute)
   */
  url: _propTypes.default.string,
  /**
   * Extra http headers to pass to the autocomplete endpoint defined by `url`
   */
  headers: _propTypes.default.object,
  /**
   * Key/value pairs to be added to the url query string
   */
  queryString: _propTypes.default.objectOf(_propTypes.default.string),
  /**
   * The maximum number of results (PER CATEGORY)
   */
  size: _propTypes.default.number,
  /**
   * An error callback for when the fetch() call to url encounters some error. First argument is the error object
   */
  onFetchError: _propTypes.default.func,
  /**
   * Whether to fetch and show typeahead results
   */
  useTypeAhead: _propTypes.default.bool,
  /**
   * Callback for the submit action, argument is the input value
   */
  onSubmit: _propTypes.default.func,
  /**
   * Callback for the select action on an item in the typeahead results. Argument is the item object
   * (required keys: value + label).
   */
  onSelect: _propTypes.default.func,
  /**
   * Whether hitting the enter key will cause the submit action. Only applies when typeahead is disabled
   * or no options are listed.
   */
  submitOnEnter: _propTypes.default.bool,
  /**
   * Whether hitting the enter key will cause the submit action, regardless of typeahead state.
   */
  submitOnEnterAlways: _propTypes.default.bool,
  /**
   * Version of the Search API to use. Defaults to 'v8'.
   */
  version: _propTypes.default.oneOf(['v8', 'v9']),
  /**
   * Function for transforming query string parameters.
   * Provides access to the query params object.
   * Should return an object.
   */
  transformQueryStringParams: function (props, propName, componentName) {
    if (props.version === 'v8' && props[propName] != null) {
      return new Error(`${propName} is not supported for version ${props.version}.`);
    }
    if (props.version === 'v9') {
      _propTypes.default.checkPropTypes({
        [propName]: _propTypes.default.func
      }, props, propName, componentName);
    }
  }
};

// NOTE: adding Downshift.defaultProps here was causing an error
Typeahead.defaultProps = {
  placeholder: '',
  placement: 'below',
  value: '',
  categories: '',
  url: '/typeahead',
  headers: null,
  queryString: null,
  size: 10,
  useTypeAhead: true,
  onSubmit: () => null,
  onSelect: () => null,
  submitOnEnter: false,
  submitOnEnterAlways: false,
  onFetchError: () => null,
  version: 'v8'
};
var _default = exports.default = Typeahead;
Typeahead.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onStateChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "changes",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getCurrentUrlParams",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "dsOnKeyHandler",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }, {
      "name": "closeMenu",
      "type": null
    }, {
      "name": "highlightedIndex",
      "type": null
    }, {
      "name": "inputValue",
      "type": null
    }],
    "returns": null
  }, {
    "name": "clearSelectAndUpdateInput",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "inputValue",
      "type": null
    }],
    "returns": null
  }, {
    "name": "convertValueToLabel",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "fetchResponse",
    "docblock": "Fetch the typeahead response from the Search Service proxy",
    "modifiers": ["async"],
    "params": [],
    "returns": null,
    "description": "Fetch the typeahead response from the Search Service proxy"
  }],
  "displayName": "Typeahead",
  "props": {
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Used to display placeholder text inside the input.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placement": {
      "defaultValue": {
        "value": "'below'",
        "computed": false
      },
      "description": "Sets position of typeahead results list (\"above\" | \"below\")",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The value that the input will be initialized with.\nThe input does not become \"controlled\" - it is simply a starting value",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "categories": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The typeahead categories to include:\nfor v8, see:\n https://support.kyruus.com/hc/en-us/articles/360000680183-Integrating-Typeahead-with-Search\nfor v9, see:\n https://support.kyruus.com/hc/en-us/articles/360051068671-Integrating-Typeahead-with-Search",
      "type": {
        "name": "custom",
        "raw": "function (props, propName, componentName) {\n  if (props.version === 'v8') {\n    PropTypes.checkPropTypes(\n      {\n        [propName]: PropTypes.oneOfType([\n          PropTypes.arrayOf(\n            PropTypes.shape({\n              category: PropTypes.string,\n              display: PropTypes.string\n            })\n          ),\n          PropTypes.string\n        ])\n      },\n      props,\n      propName,\n      componentName\n    );\n  }\n  if (props.version === 'v9') {\n    const catStrings = [\n      'clinical_keywords',\n      'conditions_symptoms',\n      'location_name',\n      'network_affiliation',\n      'practice_group',\n      'primary_care',\n      'provider_name',\n      'specialties',\n      'treatments_procedures',\n      'marketable_location_type',\n      'marketable_locations',\n      'marketable_location_services'\n    ];\n    PropTypes.checkPropTypes(\n      {\n        [propName]: PropTypes.oneOfType([\n          PropTypes.arrayOf(PropTypes.oneOf(catStrings)),\n          PropTypes.arrayOf(\n            PropTypes.shape({\n              display: PropTypes.string,\n              category: PropTypes.oneOf(catStrings)\n            })\n          )\n        ])\n      },\n      props,\n      propName,\n      componentName\n    );\n  }\n}"
      },
      "required": false
    },
    "url": {
      "defaultValue": {
        "value": "'/typeahead'",
        "computed": false
      },
      "description": "The url of the Search Service typeahead proxy (can be relative or absolute)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "headers": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Extra http headers to pass to the autocomplete endpoint defined by `url`",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "queryString": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Key/value pairs to be added to the url query string",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "description": "The maximum number of results (PER CATEGORY)",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "useTypeAhead": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Whether to fetch and show typeahead results",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onSubmit": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "Callback for the submit action, argument is the input value",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onSelect": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "Callback for the select action on an item in the typeahead results. Argument is the item object\n(required keys: value + label).",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "submitOnEnter": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether hitting the enter key will cause the submit action. Only applies when typeahead is disabled\nor no options are listed.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "submitOnEnterAlways": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether hitting the enter key will cause the submit action, regardless of typeahead state.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onFetchError": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "An error callback for when the fetch() call to url encounters some error. First argument is the error object",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "version": {
      "defaultValue": {
        "value": "'v8'",
        "computed": false
      },
      "description": "Version of the Search API to use. Defaults to 'v8'.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'v8'",
          "computed": false
        }, {
          "value": "'v9'",
          "computed": false
        }]
      },
      "required": false
    },
    "transformQueryStringParams": {
      "description": "Function for transforming query string parameters.\nProvides access to the query params object.\nShould return an object.",
      "type": {
        "name": "custom",
        "raw": "function (props, propName, componentName) {\n  if (props.version === 'v8' && props[propName] != null) {\n    return new Error(\n      `${propName} is not supported for version ${props.version}.`\n    );\n  }\n  if (props.version === 'v9') {\n    PropTypes.checkPropTypes(\n      {\n        [propName]: PropTypes.func\n      },\n      props,\n      propName,\n      componentName\n    );\n  }\n}"
      },
      "required": false
    }
  },
  "composes": ["downshift"]
};